import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import { MenuItem } from "@mui/material";

function JSBackgroundSize({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      nullable={true}
      options={[
        <MenuItem key={"default"} value={""}>
          Default
        </MenuItem>,
        <MenuItem key={"cover"} value={"cover"}>
          Cover
        </MenuItem>,
        <MenuItem key={"contain"} value={"contain"}>
          Contain
        </MenuItem>,
      ]}
      rules={{ required }}
    />
  );
}

export const JSBackgroundSizeComponent: JSInputComponent = {
  Component: JSBackgroundSize,
  handlesCssProperties: ["backgroundSize"],
};
